export class PinUtils {
  private static pinSvgStrCache: Promise<string>;
  private static pinSvgCache: Promise<SVGAElement>;
  private static pinSvgUrlCacheMap = new Map<string, Promise<string>>();

  static createPin(caracter: string) {
    caracter = String(caracter);

    let promise: Promise<string>;
    if (this.pinSvgUrlCacheMap.has(caracter)) {
      promise = this.pinSvgUrlCacheMap.get(caracter);
    } else {
      promise = PinUtils._getPinSvg().then((svg) => {
        return new Promise((resolve) => {
          svg.setAttribute('fill', '#F3CA54');

          const blob = new Blob([svg.outerHTML], { type: 'image/svg+xml' });
          const url = URL.createObjectURL(blob);

          const image = new Image();
          image.decoding = 'async';
          image.src = url;
          image.onload = () => {
            image.onload = null;

            const canvas = document.createElement(
              'canvas'
            ) as HTMLCanvasElement;
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(image, 0, 0);

            const pxRelativeHeightFn = (v: number) => {
              const value = (v * canvas.height) / 26;
              return Number(value.toPrecision(4));
            };

            ctx.font = `${pxRelativeHeightFn(13)}px Arial black`;
            ctx.fillStyle = '#000000';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'top';
            ctx.fillText(
              caracter,
              canvas.width / 2,
              pxRelativeHeightFn(5),
              canvas.width
            );

            const resUrl = canvas.toDataURL('image/png', 1);
            resolve(resUrl);
          };
        });
      });
      this.pinSvgUrlCacheMap.set(caracter, promise);
    }

    return promise;
  }

  private static _getPinSvg() {
    if (!PinUtils.pinSvgCache) {
      PinUtils.pinSvgCache = PinUtils._getPinSvgStr().then((svgStr) => {
        const el = document.createElement('div');
        el.innerHTML = svgStr;
        const svg = el.firstChild as SVGAElement;
        return svg;
      });
    }

    return PinUtils.pinSvgCache;
  }

  private static _getPinSvgStr() {
    if (!PinUtils.pinSvgStrCache) {
      PinUtils.pinSvgStrCache = fetch('assets/icons/location-pin.svg').then(
        (x) => x.text()
      );
    }

    return PinUtils.pinSvgStrCache;
  }
}
